import React, { useMemo, useEffect } from 'react';
import Presentations from './presentations/Presentations';
import styles from './LessonSidebar.module.scss';
import { LessonType as TeacherLessonType, LastVisitedLessonContentFragment, SllModule, SllLesson } from '@api/graphql-codegen';
import { useStandaloneContent } from '@src/hooks/useStandaloneContent';
import { sortByAlphabetic, sortByPosition } from '@utils/helpers';
interface Props {
  lesson: SllLesson;
  quizContents?: SllModule[];
  lastVisitedLesson?: LastVisitedLessonContentFragment;
  closeNav?: () => void;
  startLesson: (lesson: SllLesson) => void;
  isMaterials?: boolean;
  isPreProgramQuiz?: boolean;
}

const LessonSidebar = ({ lesson, closeNav, startLesson, isMaterials, isPreProgramQuiz, quizContents }: Props) => {

  const { setContent, content, setLesson } = useStandaloneContent();

  const modules = useMemo(() => {
    if (isMaterials) {
      return [...lesson.materials || []].filter(module => module?.lastInLesson !== true).sort(sortByPosition)
    } else if (isPreProgramQuiz) {
      return [...quizContents || []].sort(sortByAlphabetic)
    }

    return [...lesson.presentation || []].filter(module => module?.lastInLesson !== true).sort(sortByPosition)
  }, [lesson, isMaterials, isPreProgramQuiz, quizContents]);

  const listwrapper = useMemo(() => [styles.wrapper, styles.opened].join(' '), []);

  useEffect(() => {
    if (lesson) {
      setLesson(lesson)
    }
  }, [lesson, setLesson])

  useEffect(() => {
    if (modules.length > 0 && !content) {
      setContent(modules.at(0) as any)  
    }
  }, [content, modules, setContent])

  return (
    <div className={listwrapper}>
      <section className={styles.list}>
        <Presentations
          lessonOpened={true}
          lessonType={TeacherLessonType.PRESENTATION}
          lesson={lesson}
          contents={modules as SllModule[]}
          closeNav={closeNav}
        />
      </section>
    </div>
  )
}

export default LessonSidebar;
